export class StepUpCancelledError extends Error {
  constructor() {
    super('Step-up authentication was cancelled by the user.');
    this.name = 'StepUpCancelledError';
  }
}
